// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1aX2E","label":"Radio_label__1Ter4","checkMark":"Radio_checkMark__25kvT","disabled":"Radio_disabled__1uVwa"};